<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-wallet"/> {{caption}}
        <div class="card-header-actions">
          
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      
    </CCardBody>
  </CCard>
</template>

<script>
import ws from '../../services/products';
import store from '../../store'

export default {
  name: 'MyPaymentsList',
  components: { },
  props: { 
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    is_primary: Boolean,
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'description', label: 'Descripción'},
        {key: 'price', label: this.is_primary ? 'Costo': 'Precio'},
        {key: 'stock', label: 'Existencia'},
        {key: 'actions', label: 'Acciones', class: 'actions' },
      ],
      toasts: []
    }
  },
  methods: {
    storeModal (is_primary) {
      this.$refs.productModal.storeModal(is_primary);
    },
    updateModal (item) {
      this.$refs.productModal.updateModal(item);
    },
    transactionModal (item) {
      this.$refs.transactionModal.showModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show(item.is_primary ? "Eliminar Materia Prima" : "Eliminar Producto", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async storeTransaction(data) {
      let response = await ws.storeTransaction(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async getExcel() {
      let response = await ws.excel({is_primary: this.is_primary});
      
      if(response.type == "success"){
        window.location = response.data;
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
